// Constants
export const info_ingresos = () => {
  return {
    info_ingresos: {
      id: {
        namepath: ['afiliacion_pendientes','afiliacion_nueva','servicios_afiliacion','afiliacion_servicios','afiliacion_registros','informes_afiliaciones'],        
        type: "number",
        label: "id",
        placeholder: "",
        description: "",
        validate: "",
        datatype: {
          type: "input",
          disabled: true,
          predeterminate: null,
        }
      },
      id_datos_razon: {
        type: "text",
        label: "razon",
        placeholder: "",
        namepath: ['afiliacion_nueva','servicios_afiliacion','afiliacion_servicios','afiliacion_registros','informes_afiliaciones'],
        description: "",
        validate: "",
        datatype: {
          type: "select",
          disabled: false,
          predeterminate: 1,
          list: "datos_razon",
          label: 'name'
        }
      },
      id_datos_asesor: {
        type: "text",
        label: "Asesor",
        placeholder: "",
        namepath: ['afiliacion_nueva','servicios_afiliacion','afiliacion_servicios','afiliacion_registros','informes_afiliaciones'],
        description: "",
        validate: "",
        datatype: {
          type: "select",
          disabled: false,
          predeterminate: 1,
          list: "datos_asesor",
          label: 'name'
        }
      },
      id_list_documento: {
        type: "text",
        label: "Tipo Documento",
        placeholder: "",
        namepath: ['afiliacion_pendientes','afiliacion_nueva','servicios_afiliacion','afiliacion_servicios','afiliacion_registros','informes_afiliaciones'],
        description: "",
        validate: "",
        datatype: {
          type: "select",
          disabled: false,
          predeterminate: 1,
          list: "list_documento",
          label: 'name'
        }
      },
      id_list_forma: {
        type: "text",
        label: "Forma de pago",
        placeholder: "",
        namepath: ['afiliacion_nueva','servicios_afiliacion','afiliacion_servicios','afiliacion_registros','informes_afiliaciones','afiliacion_descargar'],
        description: "",
        validate: "",
        datatype: {
          type: "select",
          disabled: false,
          predeterminate: 4,
          list: "list_forma",
          label: 'name',
          agregar: true
        }
      },
      id_list_cuentas: {
        type: "text",
        label: "Cuenta",
        placeholder: "",
        namepath: ['afiliacion_nueva','servicios_afiliacion','afiliacion_servicios','afiliacion_registros','informes_afiliaciones','afiliacion_descargar'],
        description: "",
        validate: "",
        datatype: {
          type: "select",
          disabled: false,
          predeterminate: 1,
          list: "list_cuentas",
          label: 'name',
          agregar: true
        }
      },
      name: {
        type: "text",
        label: "Nombre",
        placeholder: "",
        namepath: ['afiliacion_pendientes','afiliacion_nueva','servicios_afiliacion','afiliacion_servicios','afiliacion_registros','informes_afiliaciones'],
        description: "",
        validate: "",
        datatype: {
          type: "input",
          disabled: false,
          predeterminate: null,
        }
      },
      documento: {
        namepath: ['afiliacion_pendientes','afiliacion_nueva','servicios_afiliacion','afiliacion_servicios','afiliacion_registros','informes_afiliaciones'],
        type: 'number',
        label: 'Documento',
        placeholder: '',
        description: 'documento',
        validate: '',
        datatype: {
          type: 'price', 
          disabled: false,
          predeterminate: 0,
          prepend: '',
          append: '',
        }
      },
      fecha: {
        type: "number",
        label: "fecha",
        placeholder: "",
        namepath: ['afiliacion_nueva','servicios_afiliacion','afiliacion_pendientes'],
        description: "",
        validate: "",
        datatype: {
          type: "date",
          disabled: false,
          predeterminate: "",
        }
      },
      consignacion: {
        type: "number",
        label: "Fecha cons.",
        placeholder: "",
        namepath: ['afiliacion_nueva','servicios_afiliacion','afiliacion_pendientes','afiliacion_descargar','afiliacion_registros','afiliacion_servicios','informes_afiliaciones'],
        description: "",
        validate: "",
        datatype: {
          type: "date",
          disabled: false,
          predeterminate: null,
        }
      },
      direccion: {
        namepath: ['afiliacion_pendientes','afiliacion_nueva','servicios_afiliacion','afiliacion_servicios','afiliacion_registros','informes_afiliaciones'],
        type: 'text',
        label: 'Dirección',
        placeholder: '',
        description: 'Dirección',
        validate: '',
        datatype: {
          type: 'input', 
          disabled: false,
          predeterminate: '',
        }
      },
      email: {
        namepath: ['afiliacion_pendientes','afiliacion_nueva','servicios_afiliacion','afiliacion_servicios','afiliacion_registros','informes_afiliaciones'],
        type: 'text',
        label: 'Email',
        placeholder: '',
        description: 'Email',
        validate: '',
        datatype: {
          type: 'input', 
          disabled: false,
          predeterminate: '',
        }
      },
      telefonos: {
        namepath: ['afiliacion_pendientes','afiliacion_nueva','servicios_afiliacion','afiliacion_servicios','afiliacion_registros','informes_afiliaciones'],
        type: 'text',
        label: 'Teléfonos',
        placeholder: '',
        description: 'Telefonos',
        validate: '',
        datatype: {
          type: 'input', 
          disabled: false,
          predeterminate: '',
        }
      },
      descripcion: {
        type: "text",
        label: "Descripcion",
        placeholder: "",
        namepath: ['afiliacion_nueva','servicios_afiliacion','afiliacion_servicios','afiliacion_registros','informes_afiliaciones'],
        description: "",
        validate: "",
        datatype: {
          type: "input",
          disabled: false,
          predeterminate: "Afiliación y trámites en los servicios de seguridad social ",
        }
      },
      valor: {
        namepath: ['afiliacion_nueva','servicios_afiliacion','afiliacion_servicios','afiliacion_registros','informes_afiliaciones'],
        type: 'number',
        label: 'Valor',
        placeholder: '',
        description: 'Valor',
        validate: '',
        datatype: {
          type: 'price', 
          disabled: false,
          predeterminate: 0,
          prepend: '$',
          append: '',
        }
      },
      reporte: {
        namepath: ['afiliacion_nueva','servicios_afiliacion','afiliacion_servicios','afiliacion_registros','informes_afiliaciones'],
        type: 'number',
        label: 'Reporte',
        placeholder: '',
        description: 'Reporte',
        validate: '',
        datatype: {
          type: 'price', 
          disabled: false,
          predeterminate: 0,
          prepend: '$',
          append: '',
        }
      },
      consecutivo: {
        type: "number",
        label: "Consecutivo",
        placeholder: "",
        namepath: ['afiliacion_nueva','servicios_afiliacion','afiliacion_servicios','afiliacion_registros','informes_afiliaciones'],
        description: "",
        validate: "",
        datatype: {
          type: "input",
          disabled: false,
          predeterminate: 0,
        }
      },    
      label_consecutivo: {
        type: "text",
        label: "Consecutivo",
        placeholder: "",
        namepath: ['afiliacion_nueva','servicios_afiliacion','afiliacion_servicios','afiliacion_registros','informes_afiliaciones'],
        description: "",
        validate: "",
        datatype: {
          type: "input",
          disabled: false,
          predeterminate: "REGISTRO Nº",
        }
      },    
      tipo: {
        type: "number",
        label: "tipo",
        placeholder: "",
        namepath: ['afiliacion_nueva','servicios_afiliacion','afiliacion_servicios','afiliacion_registros','informes_afiliaciones'],
        description: "",
        validate: "",
        datatype: {
          type: "input",
          disabled: false,
          predeterminate: 0,
        }
      },  
      anulado: {
        type: "number",
        label: "tipo",
        placeholder: "",
        namepath: ['afiliacion_registros','informes_afiliaciones'],
        description: "",
        validate: "",
        datatype: {
          type: "price",
          disabled: false,
          predeterminate: 0,
        }
      },  
      observacion: {
        type: "text",
        label: "Observaciones",
        placeholder: "",
        namepath: ['afiliacion_nueva','servicios_afiliacion','afiliacion_servicios','afiliacion_registros','informes_afiliaciones'],
        description: "",
        validate: "",
        datatype: {
          type: "textarea",
          disabled: false,
          predeterminate: '',
          rows: 5
        }
      },
      servicios: {
        type: "boolean",
        label: "Solo servicios",
        placeholder: "",
        namepath: ['servicios_afiliacion'],
        description: "",
        validate: "",
        datatype: {
          type: "check",
          disabled: false,
          predeterminate:0,
        }
      },    
      nota_delete: {
        type: "text",
        label: "Nota",
        placeholder: "",
        namepath: ['afiliacion_registros','afiliacion_descargar'],
        description: "",
        validate: "required",
        datatype: {
          type: "input",
          disabled: false,
          predeterminate: null
        }
      }, 
    }
  }
}


